export default __webpack_public_path__ + "static/media/edit-score.52136a8b.svg";